"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityMetadataToJSON = exports.EntityMetadataFromJSONTyped = exports.EntityMetadataFromJSON = exports.instanceOfEntityMetadata = void 0;
/**
 * Check if a given object implements the EntityMetadata interface.
 */
function instanceOfEntityMetadata(value) {
    var isInstance = true;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;
    isInstance = isInstance && "deletedAt" in value;
    return isInstance;
}
exports.instanceOfEntityMetadata = instanceOfEntityMetadata;
function EntityMetadataFromJSON(json) {
    return EntityMetadataFromJSONTyped(json, false);
}
exports.EntityMetadataFromJSON = EntityMetadataFromJSON;
function EntityMetadataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (json['updatedAt'] === null ? null : new Date(json['updatedAt'])),
        'deletedAt': (json['deletedAt'] === null ? null : new Date(json['deletedAt'])),
    };
}
exports.EntityMetadataFromJSONTyped = EntityMetadataFromJSONTyped;
function EntityMetadataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdAt': (value.createdAt.toISOString()),
        'updatedAt': (value.updatedAt === null ? null : value.updatedAt.toISOString()),
        'deletedAt': (value.deletedAt === null ? null : value.deletedAt.toISOString()),
    };
}
exports.EntityMetadataToJSON = EntityMetadataToJSON;
